// src/ActivitiesPage.js
//
// UPDATED to full CRUD, same New/Edit/Delete pattern as ProjectsPage.js.
// Also fixes the table display: uses activity.project_label (the new
// read-only display field from ActivitySerializer) instead of the raw
// project ID or the old project_name field that doesn't exist in the
// real backend.

import { useState, useEffect } from 'react';
import { API_BASE_URL } from './apiConfig';
import ActivityForm from './ActivityForm';

function ActivitiesPage({ token }) {
  const [activities, setActivities] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [editingActivity, setEditingActivity] = useState(null);

  const refreshActivities = () => {
    fetch(`${API_BASE_URL}/api/activities/`, {
      headers: { Authorization: `Token ${token}` },
    })
      .then((res) => res.json())
      .then((data) => {
        if (Array.isArray(data)) setActivities(data);
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    refreshActivities();
  }, [token]);

  const handleNewClick = () => {
    setEditingActivity(null);
    setShowForm(true);
  };

  const handleEditClick = (activity) => {
    setEditingActivity(activity);
    setShowForm(true);
  };

  const handleSaved = () => {
    setShowForm(false);
    setEditingActivity(null);
    refreshActivities();
  };

  const handleCancel = () => {
    setShowForm(false);
    setEditingActivity(null);
  };

  const handleDelete = async (activity) => {
    const confirmed = window.confirm(`Delete activity "${activity.name}"? This cannot be undone.`);
    if (!confirmed) return;
    await fetch(`${API_BASE_URL}/api/activities/${activity.id}/`, {
      method: 'DELETE',
      headers: { Authorization: `Token ${token}` },
    });
    refreshActivities();
  };

  if (loading) return <p className="text-gray-500">Loading activities...</p>;

  return (
    <div>
      <div className="flex justify-between items-center mb-4">
        <h1 className="text-2xl font-bold">Activities</h1>
        <button onClick={handleNewClick} className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700">
          + New Activity
        </button>
      </div>

      {showForm && (
        <ActivityForm
          token={token}
          activity={editingActivity}
          onSaved={handleSaved}
          onCancel={handleCancel}
        />
      )}

      <table className="w-full bg-white rounded shadow">
        <thead>
          <tr className="text-left border-b">
            <th className="p-3">Activity Name</th>
            <th className="p-3">Project</th>
            <th className="p-3">Planned Date</th>
            <th className="p-3">Status</th>
            <th className="p-3">Actions</th>
          </tr>
        </thead>
        <tbody>
          {activities.map((activity) => (
            <tr key={activity.id} className="border-b hover:bg-gray-50">
              <td className="p-3">{activity.name}</td>
              <td className="p-3">{activity.project_label}</td>
              <td className="p-3">{activity.planned_date}</td>
              <td className="p-3 capitalize">{activity.status.replace('_', ' ')}</td>
              <td className="p-3">
                <button onClick={() => handleEditClick(activity)} className="text-blue-600 text-sm hover:underline mr-3">Edit</button>
                <button onClick={() => handleDelete(activity)} className="text-red-600 text-sm hover:underline">Delete</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default ActivitiesPage;
